import { FunctionComponent } from 'react';
import { Markdown } from '@/components/Layout/Markdown';
import { Box, Stack, Typography } from '@mui/material';
import { BookingChannelTabs } from '@/pages/productConfiguration/components/ProductConfigurationDetail/BookingChannelTabs';

export const ProductPageDetails: FunctionComponent = () => {
    return (
        <Box>
            <Stack spacing={3}>
                <Markdown source='<p><b>Hier können Sie</b><br><ul><li>Die Anzeige der Ticketangebote im Webshop zeitlich eingrenzen</li><li>Die Buchungsarten für die einzelnen Buchungskanäle definieren</li><li>Promotion-Codes hinterlegen, um Angebote nur für bestimmte Nutzergruppen sichtbar zu machen</li></ul><br /><!-- react-text: 33 -->Ihre Tickets sind hier nach der im Buchungssystem (AXESS / SKIDATA) hinterlegten Ticketbeschreibung aufgelistet.<!-- /react-text --><br><!-- react-text: 35 -->Eine Konfiguration bezieht sich daher immer auf alle Tickets mit gleicher Ticketbeschreibung.<!-- /react-text --><br><br><!-- react-text: 38 -->Für Promotion-Tickets empfehlen wir, eine eindeutig abweichende Ticketbeschreibung in Ihrem Buchungssystem zu hinterlegen.<!-- /react-text --></p>' />
                <Typography variant='h6'>Buchungsarten</Typography>
                <Typography gutterBottom>
                    Als Standard-Buchungsoption ist die Ticketbuchung auf
                    Keycards („Keycard“) aktiviert. Optional können Unternehmen
                    mit SKIDATA-Zutrittssystem ihren Gästen hier weitere
                    Buchungsoptionen aktivieren. Bitte stellen Sie vorab sicher,
                    dass die technischen Voraussetzungen gegeben sind und dass
                    auch alle Kassa-Mitarbeiter über ggf. anfallende Aufgaben
                    (Ticket Erstellungen / Versand etc.) informiert
                </Typography>
                <BookingChannelTabs />
            </Stack>
        </Box>
    );
};
